import React from "react";
import { useLang } from "@/contexts/LanguageContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import BookingWizard from "@/components/BookingWizard";

export default function AppointmentPage() {
  const { t } = useLang();
  return (
    <div className="relative min-h-screen">
      <div className="vl-noise" />
      <Header />
      <section className="max-w-3xl mx-auto px-6 pt-32 pb-24" data-testid="appointment-page">
        <div className="text-center mb-12">
          <div className="text-xs tracking-[0.35em] uppercase text-[var(--vl-gold)] mb-3">Veloura</div>
          <h1 className="font-serif-display text-4xl sm:text-5xl font-light text-[var(--vl-ivory)]">{t("booking_title")}</h1>
          <p className="text-sm text-[var(--vl-stone)] mt-4">{t("booking_sub")}</p>
        </div>
        <BookingWizard />
      </section>
      <Footer />
    </div>
  );
}
